import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const painPoints = ['Sabés perfectamente lo que tenés que hacer... pero no podés arrancar', 'Empezás mil cosas y no terminás ninguna', 'Tu cabeza tiene 50 pestañas abiertas y ninguna se cierra sola', 'Comprás cosas que no necesitás cuando estás ansiosa o agotada', 'Cada lunes prometés que esta semana va a ser diferente. Y no lo es.'];
export const PainSection = () => {
  return <section className="bg-dark text-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-221">
      <div className="max-w-4xl mx-auto" data-id="element-222">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-4xl font-serif font-bold text-center mb-8" data-id="element-223">
          ¿Alguna vez te sentiste así?
        </motion.h2>

        <div className="space-y-3 mb-10" data-id="element-224">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start gap-3 bg-white/5 p-3 sm:p-4 rounded-xl border border-white/10" data-id="element-225">
              <CheckCircle2 className="text-gold-500 flex-shrink-0 mt-0.5" size={20} data-id="element-226" />
              <p className="text-base sm:text-lg text-gray-200" data-id="element-227">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-light text-dark p-6 sm:p-8 rounded-2xl text-center shadow-xl" data-id="element-228">
          <p className="text-lg sm:text-xl leading-relaxed" data-id="element-229">
            Te sentis identificada?
          </p>
          <p className="text-xl sm:text-2xl font-bold mt-3 text-coral-600" data-id="element-230">
            Es porque nadie te explicó cómo funciona tu cerebro.
          </p>
        </motion.div>
      </div>
    </section>;
};